import { FunctionComponent, useEffect, useState } from 'react';
import Editor, { useMonaco } from '@monaco-editor/react';
import { theme } from './theme';

interface Props {
  keyFile: string;
  code: string;
  updateCode: (code: string) => void;
}

const MonacoEditor: FunctionComponent<Props> = ({ keyFile, code, updateCode }) => {
  const monaco = useMonaco();
  const [lang, setLang] = useState<string>();

  const detectLanguage = (file: string) => {
    const extension = file.split('.').pop();
    const langs = {
      js: 'javascript',
      css: 'css',
      py: 'python',
      html: 'html',
      csv: 'plaintext',
      json: 'json',
      ts: 'typescript',
      sql: 'sql',
    };
    return langs[extension] ?? 'plaintext';
  };

  useEffect(() => {
    if (monaco) {
      monaco.editor.defineTheme('platzi-theme', theme);
      monaco.editor.setTheme('platzi-theme');
    }
  }, [monaco]);

  useEffect(() => {
    setLang(detectLanguage(keyFile));
  }, [keyFile]);

  return (
    <div className="h-full grow w-full">
      <Editor
        theme="platzi-theme"
        width="100%"
        height="100%"
        language={lang}
        key={keyFile}
        defaultValue={code}
        value={code}
        onChange={(value) => updateCode(value || '')}
        options={{
          fontSize: 12,
          tabSize: 2,
          formatOnType: true,
          formatOnPaste: true,
          showUnused: true,
          folding: false,
          lineNumbersMinChars: 3,
          scrollBeyondLastLine: false,
          automaticLayout: true,
          tabCompletion: 'on',
          wordWrap: 'on',
          minimap: {
            enabled: false,
          },
        }}
      />
    </div>
  );
};

export default MonacoEditor;
